import { useDebounceFn } from '@vueuse/core'

import type { ComputedRef, WritableComputedRef } from 'vue'

import { useSidebarPrivileges } from '@entities/viewer'

import { useTeamsStore } from './store'
import { useTeamsApi } from '../../api/teams/list.hook'

const SEARCH_DEBOUNCE_MS = 400

interface FiltersTeamsReturn {
  refSearch: WritableComputedRef<string>
  canManage: ComputedRef<boolean>
  isLoading: ComputedRef<boolean>
  openCreateModal: () => void
}

export const useFiltersTeams = (): FiltersTeamsReturn => {
  const router = useRouter()
  const route = useRoute()
  const store = useTeamsStore()
  const { canManageTeams } = useSidebarPrivileges()

  const syncQueryAndReload = async (): Promise<void> => {
    await router.push({
      query: {
        ...route.query,
        q: store.getFilterSearch || undefined,
        page: undefined,
      },
    })
    await useTeamsApi()
  }

  const applySearch = useDebounceFn(() => syncQueryAndReload(), SEARCH_DEBOUNCE_MS)

  const refSearch = computed<string>({
    get: () => store.getFilterSearch ?? '',
    set: (value) => {
      store.setFilterSearch(value.trim() || null)
      void applySearch()
    },
  })

  const canManage = computed<boolean>(() => canManageTeams.value)
  const isLoading = computed<boolean>(() => store.isLoading)

  const openCreateModal = (): void => {
    store.setModalCreate(true)
  }

  return { refSearch, canManage, isLoading, openCreateModal }
}
